module.exports = __webpack_public_path__ + "static/img/Air.bcf6a8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/elements/Air.svg
// module id = 1420
// module chunks = 0